import { Button } from '../../../templates/parts/button'
import { ArrowLink } from '../../../templates/parts/arrow-link'

export class Buttons {
  constructor () {
    this.initButtons()
    this.initArrowLinks()
  }

  initButtons = () => {
    this.buttons = [...document.querySelectorAll('.js-button')]
    if (this.buttons.length <= 0) { return false }
    this.buttons.forEach(button => {
      new Button(button)
    })
  }

  initArrowLinks = () => {
    this.arrowLinks = [...document.querySelectorAll('.js-arrow-link')]
    this.arrowLinks.forEach(link => {
      new ArrowLink(link)
    })
  }
}
